import { render, staticRenderFns } from "./DraftMessageTable.vue?vue&type=template&id=604e2bb2&scoped=true&lang=pug"
import script from "./DraftMessageTable.vue?vue&type=script&lang=ts"
export * from "./DraftMessageTable.vue?vue&type=script&lang=ts"
import style0 from "./DraftMessageTable.vue?vue&type=style&index=0&id=604e2bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e2bb2",
  null
  
)

export default component.exports